define('modules/common/routes',[], function() {
    "use strict";
    var State = function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('error', {
            url: "/error",
            templateUrl: 'modules/common/view/error.tpl.html',
            controller: 'ErrorController',
            withMenu: true,
            requireToken: true
        }).state('dashboard', {
            url: "/:aliasStudio/dashboard",
            templateUrl: 'modules/common/view/dashboard.tpl.html',
            controller: 'DashboardController',
            requireToken: true,
            withMenu: false
        }).state('i-miei-dati', {
            url: "/:aliasStudio/i-miei-dati",
            templateUrl: 'modules/common/view/i-miei-dati.tpl.html',
            controller: 'IMieiDatiController',
            requireToken: true,
            withMenu: true
        }).state('fascicoli', {
            url: "/:aliasStudio/fascicoli?query",
            templateUrl: 'modules/common/view/fascicoli.tpl.html',
            controller: 'FascicoliController',
            requireToken: true,
            withMenu: true
        }).state('fascicolo', {
            abstract:true,
            url: "/:aliasStudio/fascicoli/:hrefFascicolo",
            controller: 'ParentFascicoloController',
            template: "<ui-view/>",
        }).state('fascicolo.dettagli', {
            url: "/",
            templateUrl: 'modules/common/view/fascicolo.tpl.html',
            controller: 'FascicoloController',
            requireToken: true,
            withMenu: true
        }).state('fascicolo.documenti', {
            url: "/documenti/:hrefDocumenti?idCartella",
            templateUrl: 'modules/common/view/fascicolo-documenti.tpl.html',
            controller: 'FascicoloDocumentiController',
            requireToken: true,
            withMenu: true
        }).state('fascicoloImpegni', {
            url: "/:aliasStudio/fascicolo-impegni",
            templateUrl: 'modules/common/view/fascicolo-impegni.tpl.html',
            controller: 'FascicoloImpegniController',
            requireToken: true,
            withMenu: true
        }).state('help', {
            url: "/:aliasStudio/help",
            templateUrl: 'modules/common/view/help.tpl.html',
            controller: 'HelpController',
            requireToken: true,
            withMenu: true
        });

        $urlRouterProvider.otherwise('/error');
    };
    return ["$stateProvider", '$urlRouterProvider', State];
});
